define('drops/gridLayout/gridLayout',[
    'jquery',
    'underscore',
	'lq/drop',
	'ResizeSensor'
], function ($, _, Drop, ResizeSensor) {
	'use strict';

    var defaults = {
        data: {
            rows: [
				{
					value: 1,
					unit: 'fr',
					isAspectRatioEnabled: false,
					ratioHeight: 1
				}
            ],
            columns: [
                { value: 1, unit: 'fr' }
            ],
            spaceBetweenRows: { value: 0, unit: 'px' },
			spaceBetweenColumns: { value: 0, unit: 'px' },
			isDynamiclySizedContainer: false
        }
	};

	var GridLayout = function (options) {
	    Drop.call(this, $('<div/>'), defaults, options);

		this.cellElements = [];

		return this;
	};

    Drop.extend(GridLayout, Drop);

    GridLayout.typeName = 'GridLayout';

    GridLayout.prototype.preRender = function () {
	    this.data.autoHeight = _.findWhere(this.data.rows, {isAspectRatioEnabled : true}) !== undefined;
        this.piping.visibility.apply(this);
	    this.applyPosition();
	    this.calculateRowAndColumnCssDimensions();
	    this.createCells();
	};

	GridLayout.prototype.render = function ($element) {
		return this.createAndRenderDrops($element);
	};

	GridLayout.prototype.postRender = function () {
		this.calculateSizeBasedOnRatio();
		this.setupDynamicCells();
	};

	GridLayout.prototype.createRenderPromiseForChild = function (drop) {
	    var cellElementData = this.getCellElementForChild(drop);
	    var $cellElement = cellElementData.cellElement;
		if (this.data.rows[cellElementData.rowIndex].unit === 'dy' ||
			this.data.columns[cellElementData.columnIndex].unit === 'dy') {
			var $wrapper = $('<div/>')
				.addClass('dyn-cell-child')
				.css({
					width : 'auto',
					height: 'auto',
					display: 'table',
					'pointer-events': 'none'
				}); //disable pointer/mouse-events; hard to select GridLayout in designer otherwise

			drop.$wrapper = $wrapper;
			drop.$element.css('pointer-events', 'auto');
			drop.$element.css('position', 'relative');
			drop.$element.css('inset', '');

			drop.$wrapper.appendTo($cellElement);
			drop.isInsideADynamicCell = true;

			return drop.render(drop.$wrapper)
		}
	    return drop.render($cellElement);
	};

	GridLayout.prototype.getCellElementForChild = function (drop) {
	    var rowIndex = Math.max(Math.min((drop.data.gridlayout_row || 1) - 1, this.data.rows.length - 1), 0);
	    var columnIndex = Math.max(Math.min((drop.data.gridlayout_column || 1) - 1, this.data.columns.length - 1), 0);
	    return {cellElement: this.cellElements[rowIndex][columnIndex], rowIndex: rowIndex, columnIndex: columnIndex};
	};

	GridLayout.prototype.createCells = function () {
	    var self = this;
	    this.cellElements = [];

	    _.each(self.data.rows, function (row, rowIndex) {
	        var rowElements = [];
	        var rowDimension = self.rowCssDimensions[rowIndex];

	        _.each(self.data.columns, function (column, columnIndex) {
	            var columnDimension = self.columnCssDimensions[columnIndex];

	            var $cellElement = self.createCell(
                    self.data.columns[columnIndex].unit === 'dy' || self.data.rows[rowIndex].unit === 'dy' ? '' : columnDimension.size,
                    self.data.rows[rowIndex].unit === 'dy' || self.data.columns[columnIndex].unit === 'dy' ? '' : rowDimension.size,
					columnDimension.position,
                    rowDimension.position,
                    columnIndex,
                    rowIndex);

	            rowElements.push($cellElement);
	        });

	        self.cellElements.push(rowElements);
	    });
	};

	GridLayout.prototype.calculateRowAndColumnCssDimensions = function () {
	    this.rowCssDimensions =
            this.calculateCssDimensions(this.data.rows, this.data.spaceBetweenRows);

	    this.columnCssDimensions =
            this.calculateCssDimensions(this.data.columns, this.data.spaceBetweenColumns);

	    this.$element.css({ minHeight: this.getUnitSum(this.data.rows, this.data.spaceBetweenRows, 'px') + 'px' });
	    this.$element.css({ minWidth: this.getUnitSum(this.data.columns, this.data.spaceBetweenColumns, 'px') + 'px' });
	};

	GridLayout.prototype.calculateCssDimensions = function (sizes, spaceBetween) {
	    var self = this;
	    var cssDimensions = [];

	    var fractionSum = this.getUnitSum(sizes, spaceBetween, 'fr');
	    var pixelSum = this.getUnitSum(sizes, spaceBetween, 'px');

	    var sumOfPrecedingFractions = 0;
	    var sumOfPrecedingPixels = 0;

	    _.each(sizes, function (size, index) {
	        var cssSize = self.getCssSize(size, fractionSum, pixelSum);
	        var cssPosition =
				self.getCssPosition(sumOfPrecedingFractions, sumOfPrecedingPixels, fractionSum, pixelSum);

	        cssDimensions.push({
	            size: cssSize,
                position: cssPosition
	        });

	        sumOfPrecedingFractions +=
                self.getUnitValue(size, 'fr') + self.getUnitValue(spaceBetween, 'fr');
	        sumOfPrecedingPixels +=
                self.getUnitValue(size, 'px') + self.getUnitValue(spaceBetween, 'px');
	    });

	    return cssDimensions;
	}

	GridLayout.prototype.getCssSize = function(size, fractionSum, pixelSum) {
	    if (size.unit === 'fr') {
	        var fractionPercentage = size.value / fractionSum;
	        return 'calc((100% - ' + pixelSum + 'px) * ' + fractionPercentage + ')';
	    } else {
	        return size.value + 'px';
	    }
	};

	GridLayout.prototype.getCssPosition = function (precedingFractions, precedingPixels, fractionSum, pixelSum) {
	    if (precedingFractions == 0) {
	        return precedingPixels + 'px';
	    } else {
	        var fractionPercentage = precedingFractions / fractionSum;
	        return 'calc((100% - ' + pixelSum + 'px) * ' + fractionPercentage + ' + ' + precedingPixels + 'px)';
	    }
	};

	GridLayout.prototype.getUnitValue = function(size, unit) {
	    if (size.unit === unit) {
	        return size.value;
	    }
	    return 0;
	};

	GridLayout.prototype.getUnitSum = function (sizes, spaceBetween, unit) {
	    var sum = _.chain(sizes)
            .filter(function (size) { return size.unit === unit })
            .reduce(function (sum, size) { return sum + size.value; }, 0)
            .value();
	    return sum + ((sizes.length - 1) * this.getUnitValue(spaceBetween, unit));
	};

	GridLayout.prototype.createCell = function (width, height, left, top) {
	    return $('<div/>')
            .css({
                position: 'absolute',
                boxSizing: 'border-box',
                //overflow: 'hidden', //if we hide overflow, it is currently not possible to get to a drop in the designer when it is outside of the cell bounds, also the resizer handles might not be visible + maybe it might be useful in some cases to have an element position outside of the cell bounds, z-index might be an issue in this case though
                height: height,
                width: width,
                top: top,
                left: left
            })
            .appendTo(this.$element);
	};

	GridLayout.prototype.setupDynamicCells = function () {
		if (!(this.hasDynamicCell())) {
			return;
		}

		this.data.isDynamiclySizedContainer = true;

		for (var i = 0; i < this.data.rows.length; i++) {
			for (var j = 0; j < this.data.columns.length; j++) {

				if ((this.data.rows[i].unit === 'dy' || this.data.columns[j].unit === 'dy') &&
					this.designData) {
					this.cellElements[i][j].css({ // If the cell is empyt in the designer the dev still should be able to put elements into it
						minHeight: '20px',
						minWidth: '20px'
					});
				}

				this.cellElements[i][j].css({
					top: '',
					left: '',
					position :'relative',
					'-ms-grid-row':  i+1 + '',
					'-ms-grid-column': j+1 + '',
					gridRow: i+1,
					gridColumn: j+1
				});
			}
		}

		if (this.hasDynamicColumn() || this.hasDynamicRow()) {
			this.$element.css({
				width: 'auto',
				height: 'auto'
			});
		}

		this.$element.css({
			display: window.document.documentMode ? '-ms-grid' : 'grid',
			rowGap: this.data.spaceBetweenRows.value + this.data.spaceBetweenRows.unit,
			columnGap: this.data.spaceBetweenColumns.value + this.data.spaceBetweenColumns.unit
		});
	};

	GridLayout.prototype.calculateSizeBasedOnRatio = function() {
		if (!this.data.autoHeight) {
			return;
		}

		var topMargin = 0;
		var height = 0;
		for (var i = 0; i < this.data.rows.length; i++) {
			for (var j = 0; j < this.cellElements[i].length; j++) {
				if (this.data.rows[i].isAspectRatioEnabled) {
					height = (this.data.rows[i].ratioHeight / this.data.rows[i].ratioWidth) * this.$element.outerWidth(true);
					$(this.cellElements[i][j])
						.css({
							height: height,
							top: topMargin
						});
				} else {
					height = $(this.cellElements[i][j]).outerHeight(true);
					$(this.cellElements[i][j])
						.css({
							top: topMargin
						});
				}
			}
			if ('px' === this.data.spaceBetweenRows.unit) {
				topMargin += height + this.data.spaceBetweenRows.value;
			} else {
				topMargin += height;
			}
		}

		this.$element
			.css({
				height : topMargin,
				minHeight : topMargin
			});
	};

	GridLayout.prototype.hasDynamicCell = function () {
		return this.hasDynamicRow() || this.hasDynamicColumn();
	};

	GridLayout.prototype.hasDynamicRow = function () {
		return _.some(this.data.rows, function (r) { return r.unit === 'dy'; });
	};

	GridLayout.prototype.hasDynamicColumn = function () {
		return _.some(this.data.columns, function (c) { return c.unit === 'dy'; });
	};

	GridLayout.prototype.postWindowResize = function () {
		this.calculateSizeBasedOnRatio();
		this.setupDynamicCells();
	};

	GridLayout.prototype.resetPositioningForChild = function(childDrop) {
	    childDrop.$element.css({
            left: 'auto',
            right: 'auto',
            top: 'auto',
            bottom: 'auto',
            position: 'relative'
        });
    };

	GridLayout.prototype.applyPositionForChild = function (childDrop) {
		var self = this;
		if (!childDrop.isInsideADynamicCell) {
			Drop.prototype.applyPositionForChild.call(self, childDrop);
		} else {
			if (childDrop.applyPositionForChild && childDrop.data.isDynamiclySizedContainer) {
				childDrop.applyPositionForChild(childDrop);
			} else {
				self.resetPositioningForChild(childDrop);
				var sizeCss = {};
				sizeCss.width = childDrop.data.size.x + 'px';
				sizeCss.height = childDrop.data.size.y + 'px';
				childDrop.$element.css(sizeCss);
			}
		}
    };

	return GridLayout;
});


